module.exports = __webpack_public_path__ + "img/HK.b953ca2c.svg";